// Hydrates every [data-impact-stats] on the page — the Builder.io Custom Code
// block that uses the markup in snippets/impact-stats-builder.liquid. Loaded on
// every page from layout/theme.liquid.
//
// Figures come from the same feed as the top banner
// (assets/impact-banner-ticker.js), so this makes no request of its own:
//   [data-impact-stat="raised"]  dollars raised, "$3.6 M"
//   [data-impact-stat="hours"]   hours of change, "1.24 M"
// Anything else in the strip (the "30+ causes supported" cell) is static copy.
//
// The strip ships hidden and is revealed once the stylesheet has landed and
// the figures are written, so it never paints unstyled or half-filled.

(function () {
  if (window.__impactStatsLoaded) return;
  window.__impactStatsLoaded = true;

  // layout/theme.liquid loads the stylesheet async. Resolved either way after
  // 3s rather than holding the strip hostage to a stylesheet that never lands.
  var stylesReady = new Promise(function (resolve) {
    var link = document.querySelector('link[href*="impact-stats.css"]');
    if (!link || link.sheet) return resolve();
    link.addEventListener('load', resolve, { once: true });
    link.addEventListener('error', resolve, { once: true });
    setTimeout(resolve, 3000);
  });

  /** 1,616,420 -> "1.62 M", 1,600,000 -> "1.6 M", 48,200 -> "48.2 K". */
  function compact(value) {
    if (value >= 1e6) return Math.round((value / 1e6) * 100) / 100 + ' M';
    if (value >= 1e3) return Math.round((value / 1e3) * 100) / 100 + ' K';
    return value.toLocaleString('en-US');
  }

  /** 3,714,426 -> "$3.71 M", 840,000 -> "$840,000". */
  function money(value) {
    return '$' + compact(value);
  }

  // The banner feed's days_of_school x 3 is the dollars raised, so
  // days_of_school itself is the hours of change.
  function figures(data) {
    var hours = data && parseInt(data.days_of_school, 10);
    if (!(hours > 0)) return null;
    return { raised: money(hours * 3), hours: compact(hours) };
  }

  function fill(root, values) {
    root.querySelectorAll('[data-impact-stat]').forEach(function (el) {
      var value = values[el.dataset.impactStat];
      if (!value) return;
      el.textContent = value;
    });

    stylesReady.then(function () {
      root.hidden = false;
    });
  }

  function init(root) {
    if (root.dataset.impactStatsInit === 'true') return;
    root.dataset.impactStatsInit = 'true';

    function render(data) {
      var values = figures(data);
      if (values) fill(root, values);
    }

    if (window.OlivelaImpactBenefit) return render(window.OlivelaImpactBenefit);

    try {
      var cached = JSON.parse(localStorage.getItem('impact_benefit_data') || 'null');
      if (cached && cached.data) render(cached.data);
    } catch (error) {}

    document.addEventListener('olivela:impact-benefit', function (event) {
      render(event.detail);
    });
  }

  var scanFrame = 0;

  function scan() {
    scanFrame = 0;
    document.querySelectorAll('[data-impact-stats]').forEach(init);
  }

  function scheduleScan() {
    if (!scanFrame) scanFrame = requestAnimationFrame(scan);
  }

  // Markup that arrives on its own terms (Builder.io) calls this rather than
  // waiting to be noticed.
  window.ImpactStats = { scan: scheduleScan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Builder.io mounts its custom-code blocks whenever its own bundle gets
  // round to it, which on a heavy page is well past any fixed deadline — so
  // this keeps watching. Each burst of mutations costs one querySelectorAll on
  // the next frame.
  new MutationObserver(scheduleScan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', scheduleScan);
})();
